import moment from 'moment-timezone'
import ManualEta from 'utils/manualEtaStatus'
import TIME_CONSTANTS from 'constants/datetime'
import { KEYED_SHIPMENT_STATUSES } from 'constants/shipments'

export const createManualEta = (state, props) => {
  const { nextStatus } = state
  const { status, stops } = props.shipment
  let { currentStopIndex } = status
  /* if we are at In Transit, we need to update currentStop to be +1
  in order that the ETA checked will be the delivery ETA */
  if (KEYED_SHIPMENT_STATUSES.in_transit.label.includes(nextStatus)) currentStopIndex += 1
  const currentStop = stops[currentStopIndex]
  let { startAt: scheduledEta } = currentStop.appointment
  const { timezone } = currentStop.appointment
  if (currentStop.appointment.appointmentType === 'FCFS') {
    const d = moment
      .tz(currentStop.appointment.endAt, TIME_CONSTANTS.iso8601Format, timezone)
      .subtract(2, 'hours')
    scheduledEta = d.format()
  }
  const formattedTime = moment(state.etaDate).format(TIME_CONSTANTS.yearFirst)
  const dateTimeString = `${formattedTime} ${state.etaTime}`
  return new ManualEta(dateTimeString, scheduledEta, timezone)
}

export const lessThanHours = (timestamp, hours) =>
  Math.abs(moment(timestamp).diff(moment(), 'h')) <= hours
